import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'

const BoardMeetingDateModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // superuser role
    boardMeetingDate, onBoardMeetingDateChange, boardMeetingDateError, setboardMeetingDateError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Update date'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputDateUI context={context} name='date' label='Board meeting date'
            selectedDateISO={boardMeetingDate} onChange={onBoardMeetingDateChange}
            error={boardMeetingDateError} setError={setboardMeetingDateError}
        />
    </ModalFormUI>

export default BoardMeetingDateModalUI
